import { i18n } from '@/i18n'

export default (params) => {
  return [
    {
      icon: 'certificates',
      name: i18n.t('certificates.header'),
      path: 'certificates',
      use_parent_params: true,
      params_required: ['idEmpresa', 'serial', 'tipo'],
      registerNavFromMenu: false,
      sc: [
        {
          name: i18n.t('certificates.detail_replace'),
          path: 'certificates/replace',
          params,
          registerNavFromMenu: false,
          sc: [] // shorcuts
        }
      ]
    }
  ]
}
